import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { Meta } from 'src/app/_models/meta';
import { UntypedFormGroup, FormControl } from '@angular/forms';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-mapa-metas-resultado',
  standalone: false,
  templateUrl: './mapa-metas-resultado.component.html',
  styleUrls: ['./mapa-metas-resultado.component.scss']
})
export class MapaMetasResultadoComponent implements OnInit {

  @Input()
  metas$: Observable<Meta[]>;
  @Input()
  categorias: any[];
  @Input()
  materias: any[];
  @Input()
  grados: any[];
  @Input()
  ambitos: any[];
  @Input()
  tags: any[];
  @Input()
  guardando$: Observable<boolean>;
  @Output()
  importarEvent: EventEmitter<Meta[]>;
  @Output()
  cerrarEvent: EventEmitter<null>;
  @Input()
  metasAImportar: Array<Meta>;
  @Input()
  filterForm: UntypedFormGroup;

  todos = false;

  displayedColumns = ['id', 'categoria', 'descripcion'];

  // = new FormGroup({
  //   id: new FormControl(''),
  //   text: new FormControl(''),
  //   categorias: new FormControl([]),
  //   materias: new FormControl([]),
  //   grados: new FormControl([]),
  //   ambitos: new FormControl([]),
  //   tags: new FormControl([]),
  // });

  metasFilter$: Observable<Meta[]>;

  metasFiltradas$: Observable<MatTableDataSource<Meta>>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor() {
    this.importarEvent = new EventEmitter();
    this.cerrarEvent = new EventEmitter();
  }

  ngOnInit(): void {
    this.metasFilter$ = this.metas$.pipe(
      map(data => {
        if (data.length === 0) {
          this.filterForm.get('text').setValue('');
        }
        data.forEach(element => {
          const field = element.txtES + ' ' + element.txtEN + ' ' + element.txtFR;
          element['filterParam'] = field.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          element['filterCursoParam'] = element.cursos.map(curso => curso.id);
          element['filterCategoriaId'] = element.categoria.ordenAgrupador;
          element['filterAmbitosParam'] = element.ambitos.map(ambito => ambito.id);
          element['filterTagsParam'] = element.tags.map(tag => tag.id);
          element['filterMateriasParam'] = element.materias.map(materia => materia.id);
          element['filterSubCategoriaId'] = element.categoriaID;
        });
        return data;
      })
    );
    this.metasFiltradas$ = combineLatest([
      this.filterForm.valueChanges.pipe(startWith(this.filterForm.getRawValue())),
      this.metasFilter$
    ]).pipe(
      debounceTime(200),
        map(([formValues, metas]) => {
          return metas.filter(meta => {
            const text: string = formValues['text'];
            let filterByText = true;
            if (text) {
              text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ').forEach(element => {
                if (!meta['filterParam'].includes(element)) {
                    filterByText = false;
                }
              });
            }
            return ((filterByText || formValues['text'] === '')
            &&  (+formValues['id'] === meta.id || formValues['id'] === '')
            &&  (this.arrayFilter(meta['filterCursoParam'], formValues['grados']))
            &&  (this.arrayFilter(meta['filterMateriasParam'], formValues['materias']))
            &&  (this.arrayFilter([meta['filterCategoriaId']], formValues['categorias']))
            &&  (this.arrayFilter([meta['filterSubCategoriaId']], formValues['subCategorias']))
            &&  (this.arrayFilter(meta['filterAmbitosParam'], formValues['ambitos']))
            &&  (this.arrayFilter(meta['filterTagsParam'], formValues['tags'])));
          });
        }),
        map(data => {
          const res = new MatTableDataSource(data);
          res.paginator = this.paginator;
          return res;
        })
    );
  }

  arrayFilter(arrayObj: any[], arrayFilter: any[]): boolean {
    if (arrayFilter) {
      if (arrayFilter.length === 0) {
        return true;
      } else {
        return arrayObj.filter(value => arrayFilter.includes(value)).length > 0;
      }
    } else {
      return true;
    }
  }

  checked(checkedEvent: boolean, meta: Meta) {
    if (checkedEvent) {
      this.metasAImportar.push(meta);
    } else {
      this.metasAImportar.splice(this.metasAImportar.findIndex(item => item.id === meta.id), 1);
    }
  }

  checkTodos(checkedEvent: boolean, metas: Meta[]) {
    this.metasAImportar.splice(0, this.metasAImportar.length);
    if (checkedEvent) {
      metas.forEach(meta => {
        this.metasAImportar.push(meta);
      });
    }
    this.todos = checkedEvent;
  }

  importar() {
    this.importarEvent.emit(this.metasAImportar);
  }

  cerrar() {
    this.cerrarEvent.emit();
  }
}
